import React, { useState, useEffect } from 'react';

import CarouselItem from '@/Banner/CarouselItem'

import { getExternalPromotions,
  getBBUImagePath,
  getBBUProfileImagePath,
  getBBUDepositImagePath,
  getBBUWithDrawalImagePath,
  getBullstreetProfileImagePath,
  getBullstreetDepositImagePath,
  getBullstreetWithdrawalImagePath,
  getExternalBBUPromotionLink, getExternalBullstreetPromotionLink } from '$ACTIONS/externalPromotionRequest';

export default ({
  displayIsNone,
  width,
  whatPage,
}) => {

  const [data, setData] = useState([])

  const fnClick = (url, evtCategory, evtAction, evtName) => {
    Pushgtagdata(evtCategory, evtAction, evtName);
    if (url) { window.open(url, "_blank"); }
  };

  useEffect(async () => {
    let res = await getExternalPromotions()

    const b = res && res.isSuccess && res.result && res.result.promotionItems;
    if (!b) {
      return
    }

    let ary = [];
    const IS_AT_DEPOSIT_PAGE = whatPage=='DEPOSIT';
    const IS_AT_PROFILE_PAGE = whatPage=='PROFILE';

    const BBU_EVT_ACTION = 'Click Banner (BBU)';
    const BULLSTREET_EVT_ACTION = 'Click Banner (Bullstreets)';

    const PROFILE_BULLSTREET_EVENT_NAME = 'MemberCenter_C_BullstreetBanner';
    const DEPOSIT_BULLSTREET_EVENT_NAME = 'Deposit_C_BullstreetBanner';
    const WITHDRAWAL_BULLSTREET_EVENT_NAME = 'Withdrawal_C_BullstreetBanner';
    const PROFILE_BBU_EVENT_NAME = 'MemberCenter_C_BBUBanner';
    const DEPOSIT_BBU_EVENT_NAME = 'Deposit_C_BBUBanner';
    const WITHDRAWAL_BBU_EVENT_NAME = 'Withdrawal_C_BBUBanner';
    let aryPromoise = {};
    if (IS_AT_DEPOSIT_PAGE || IS_AT_PROFILE_PAGE) {
      let evtCategory = 'Deposit';
      let evtBullstreetName = DEPOSIT_BULLSTREET_EVENT_NAME;
      let evtBBUName = DEPOSIT_BBU_EVENT_NAME;
      if (IS_AT_PROFILE_PAGE) {
        evtCategory = 'MemberCenter';
        evtBullstreetName = PROFILE_BULLSTREET_EVENT_NAME;
        evtBBUName = PROFILE_BBU_EVENT_NAME;
      }

      let BullImgUrl = IS_AT_PROFILE_PAGE ? getBullstreetProfileImagePath(res) : getBullstreetDepositImagePath(res);
      if (BullImgUrl) {
      ary.push(
        {alt:'Bullstreet', imageURL: BullImgUrl, onClick: () => {
          fnClick(aryPromoise.linkOfBullstreet, evtCategory, BULLSTREET_EVT_ACTION, evtBullstreetName)
        }})
      }

      let BBUImgUrl = IS_AT_PROFILE_PAGE ? getBBUProfileImagePath(res) : getBBUDepositImagePath(res);
      if (BBUImgUrl) {
      ary.push({alt:'BBU', imageURL: BBUImgUrl, onClick: () => {
          fnClick(aryPromoise.linkOfBBU, evtCategory, BBU_EVT_ACTION, evtBBUName)
        }})
      }
      if (BBUImgUrl) { aryPromoise.linkOfBBU = getExternalBBUPromotionLink(); }
      if (BullImgUrl) { aryPromoise.linkOfBullstreet = getExternalBullstreetPromotionLink(); }

    } else if (whatPage=='WITHDRAWAL') {
      let evtCategory = 'Withdrawal';
      let BBUImgUrl = getBBUWithDrawalImagePath(res);
      if (BBUImgUrl) {
      ary.push(
        {alt:'BBU', imageURL: BBUImgUrl, onClick: () => {
          fnClick(aryPromoise.linkOfBBU, evtCategory, BBU_EVT_ACTION, WITHDRAWAL_BBU_EVENT_NAME)
        }})
      }
      let BullImgUrl = getBullstreetWithdrawalImagePath(res);
      if (BullImgUrl) {
      ary.push({alt:'Bullstreet', imageURL: BullImgUrl, onClick: () => {
          fnClick(aryPromoise.linkOfBullstreet, evtCategory, BULLSTREET_EVT_ACTION, WITHDRAWAL_BULLSTREET_EVENT_NAME)
        }})
      }
      if (BBUImgUrl) { aryPromoise.linkOfBBU = getExternalBBUPromotionLink(); }
      if (BullImgUrl) { aryPromoise.linkOfBullstreet = getExternalBullstreetPromotionLink(); }
    }

    if (aryPromoise) {
      await Promise.all(
          Object.keys(aryPromoise).map(k => aryPromoise[k].then(v => aryPromoise[k] = v))
        );
    }

    /* append StrapiBanner if have
    ary.push({
              imageURL: "/cn/img/sub-banner.png",
              onClick:
            })*/
    setData(ary)
  }, []);

  const divStyle = {}
  if (width) {
    divStyle.width = width
  }
  if (displayIsNone) {
    divStyle.visibility = 'hidden';
    divStyle.height = 0;
  }
  return (<div style={divStyle}><CarouselItem
    centeredSlides={true}
    showsPagination={true}
    slidesPerView="1"
    className="externalPromo-slider"
    spaceBetween={0}
    imgStyle={{marginBottom: "30px", cursor: "pointer", width: "100%"}}
    data={data} /></div>)
}